module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ack"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book has been percolating in my mind for many years, and I’m excited to finally share it with you! Big shout-outs go to my editors and art directors at C&T for helping me bring this book to life, and to my family for always supporting me. In addition, I want to send many, many thank-yous to all my sweet online friends and followers who give me endless inspiration and encouragement. Without you, I wouldn’t be able to do what I do. This book is for you.")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg3_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fe42f30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_acknowledgments.vue
// module id = 63
// module chunks = 0